import _jsx from "@babel/runtime/helpers/jsx";
import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import CircularProgress from '../CircularProgress';
import s from './CircularProgressLoader.css';
var CircularProgressLoader = function CircularProgressLoader(_ref) {
  var _ref$circularProgress = _ref.circularProgressProps,
    circularProgressProps = _ref$circularProgress === void 0 ? {
      size: 100
    } : _ref$circularProgress,
    _ref$rootClassName = _ref.rootClassName,
    rootClassName = _ref$rootClassName === void 0 ? '' : _ref$rootClassName,
    _ref$rootStyle = _ref.rootStyle,
    rootStyle = _ref$rootStyle === void 0 ? {} : _ref$rootStyle;
  return /*#__PURE__*/_jsx("div", {
    className: classNames(s.loadingWrapper, rootClassName)
  }, void 0, /*#__PURE__*/React.createElement(CircularProgress, _extends({
    styles: rootStyle
  }, circularProgressProps)));
};
export default withStyles(s)(CircularProgressLoader);